<template>
  <div class="hospitalFrame">
    <div style="font-size: 4rem">{{user.fullName}} 医生，感谢参与救助任务！！！</div>
    <div class="textCentre">
      <div style="font-size: 9rem;margin-bottom: 14rem;">海上 120 系统</div>
      <div
        v-if="isOnLine"
        style="font-size: 5rem;color:#07c160"
      >正在值班</div>
      <div
        v-if="!isOnLine"
        style="font-size: 5rem;color:#ee0a24"
      >离线</div>
    </div>
    <div class="offline">
      <van-button
        v-if="!isOnLine"
        style="font-size: 3rem;height:5rem"
        type="warning"
        @click="online()"
      >上线</van-button>
      <van-button
        v-if="isOnLine"
        style="font-size: 3rem;height:5rem"
        type="warning"
        @click="outline()"
      >下线</van-button>
      <van-button
        style="font-size: 3rem;margin-left: 2rem;height:5rem"
        type="danger"
        @click="loginout()"
      >退出登录</van-button>
    </div>
  </div>
</template>

<script>
import { clearRem, startRem } from '@/tool/rem'
import util from '@/api/util.js';
import server from '@/api/hospital.js';
export default {
  data () {
    return {
      height: window.innerHeight,
      user: { fullName: '' },
      isOnLine: false,
      roomID: '',
      bCurrentPage: false,
    }
  },
  created () {
    startRem()
    this.bCurrentPage = true
    this.user = util.userData() || {}
    this.getDocOnLineStatus()
  },
  // 生命周期 - 销毁完成
  destroyed () {
    clearRem()
  },
  methods: {
    linkHospital () {
      this.$router.push({ name: 'hospital' })
    },
    online () {
      server.onLine().then(() => {
        this.isOnLine = true
        this.timeConnect();
      })
    },
    getDocOnLineStatus () {
      server.getDocOnLineStatus().then(res => {
        this.isOnLine = res.data
        if (this.isOnLine) {
          this.timeConnect();
        }
      })
    },
    outline () {
      server.offLine().then(() => {
        this.isOnLine = false
        this.roomID = '';
      })
    },
    loginout () {
      util.loginout()
    },
    timeConnect () {
      const This = this
      setTimeout(() => {
        if (this.bCurrentPage) {
          server.checkMeeting().then((res) => {
            if (res.data) {
              this.bCurrentPage = false
              This.roomID = res.data;
              util.router('doctors-join?roomID=' + res.data);
            } else {
              This.timeConnect()
            }
          }).catch(() => {
            This.timeConnect()
          })
        }
      }, 2000)
    },

  }
}
</script>

<style scoped>
.textCentre {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.offline {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.hospitalFrame {
  background: rgb(65, 73, 88);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 6rem;
  color: #fff;
}
</style>